module.exports = "https://cdn.thelire.com/ins/resource/limit_reached.30c66f62bfa960c372dd9353abe2407d.png";